import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {TenantRoleContainerModel} from '../../../../../models/aggregates/role';
import { ApiVisa, Pagination, PagingResponseModel } from '../shared';
import { Observable } from 'rxjs';

// https://api.akaun.cloud/core2/tnt/dm/iam/roles/applet-login-ep/

@Injectable({
  providedIn: 'root'
})
export class TenantRoleLoginEPService extends BaseApiTemplateService<TenantRoleContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'iam/roles/applet-login-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'iam/roles/applet-login-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'iam/roles/applet-login-ep';
    this.httpClient = http;
  }

  public getByGuidCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    guid: any,
  ): Observable<PagingResponseModel<TenantRoleContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl +'/'+ guid + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<TenantRoleContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
  
}


